<script lang="ts" setup>
import { MagazineCategoriesProps } from "~/components/Filters/Utils/Modals/MagazineCategories.props"
import { SortingModalItemProps } from "~/components/Filters/Utils/SortingModalItem.props"
import { MAGAZINE_CATEGORIES_MODAL } from "~/utils/filters"

defineProps<MagazineCategoriesProps>()
const emit =
  defineEmits<{
    (e: "onClose"): void
    (e: "onSelectItem", item: SortingModalItemProps): void
  }>()
</script>

<template>
  <Teleport to="body">
    <FiltersUtilsSlide
      :name="MAGAZINE_CATEGORIES_MODAL"
      open-from="bottom"
      :full-screen="false"
      no-background
      @onClose="emit('onClose')"
    >
      <FiltersUtilsModalHead
        type="secondary"
        :title="$t('filters.utils.modals.categories.category')"
        @onClose="emit('onClose')"
      />
      <div id="modal-body" class="space-y-4 bg-white p-4">
        <FiltersUtilsSortingModalItem
          v-for="item in items"
          :key="item.value"
          :="item"
          @onClick="emit('onSelectItem', item)"
        />
      </div>
    </FiltersUtilsSlide>
  </Teleport>
</template>

<style lang="scss" scoped>

#modal-body {
  height: calc(100vh - 48px);
  overflow-y: auto;
}

</style>
